export * from './ProductCardV2AllergenNotice';
